var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIconTwoTone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#edf2f6",
    d: "m8.875 17.464-3.133 1.709c-.184.1-.35.223-.503.358A10.45 10.45 0 0 0 12 22c2.557 0 4.9-.915 6.722-2.434a2.8 2.8 0 0 0-.553-.37l-3.355-1.678a1.28 1.28 0 0 1-.707-1.144v-1.316q.143-.164.318-.408a7.7 7.7 0 0 0 1.042-2.102c.43-.133.748-.53.748-1.002V10.14c0-.31-.138-.586-.351-.78V7.33S16.28 4.17 12 4.17 8.137 7.33 8.137 7.33v2.03c-.214.194-.35.47-.35.78v1.405c0 .37.194.695.485.884a7 7 0 0 0 1.27 2.628v1.283c0 .468-.256.899-.667 1.123Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6e1e9",
    d: "M12.18 1.002C6.381.902 1.6 5.522 1.501 11.32a10.47 10.47 0 0 0 3.742 8.208 2.8 2.8 0 0 1 .498-.355l3.133-1.709a1.28 1.28 0 0 0 .666-1.123v-1.284s-.92-1.1-1.27-2.628a1.05 1.05 0 0 1-.486-.884V10.14c0-.309.138-.585.351-.778V7.33S7.72 4.17 12 4.17s3.863 3.16 3.863 3.16v2.032c.214.193.35.47.35.778v1.405c0 .472-.316.87-.746 1.003a7.7 7.7 0 0 1-1.043 2.101 5 5 0 0 1-.318.408v1.317c0 .484.274.928.708 1.144l3.354 1.677c.202.1.384.228.551.37a10.47 10.47 0 0 0 3.779-7.886c.1-5.798-4.52-10.578-10.319-10.677Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconTwoTone);
export default __webpack_public_path__ + "static/media/user-icon-two-tone.92819be94e389b33baa2da095e44e387.svg";
export { ForwardRef as ReactComponent };